import { ga } from 'js/analytics/adapters'

export const trackEnterBasicInformation = () => {
  ga.track('enter_basic_information')
}
